import { render, staticRenderFns } from "./biaoXingSection.vue?vue&type=template&id=c3319154&scoped=true"
import script from "./biaoXingSection.vue?vue&type=script&lang=js"
export * from "./biaoXingSection.vue?vue&type=script&lang=js"
import style0 from "./biaoXingSection.vue?vue&type=style&index=0&id=c3319154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3319154",
  null
  
)

export default component.exports